import { useState } from "react";
import apiUrls from "../../apiUrls";
import { API_SERVER_URL } from 'gatsby-env-variables-fork';

const url =
  typeof window !== "undefined"
    ? `${API_SERVER_URL}${apiUrls.quizValidation}`
    : "";

type ServerValidationResult = {
  IsValid: boolean;
  Error: string;
};

const useQuizCodeServerValidation = () => {
  const [isFetching, setIsFetching] = useState(false);

  const validateCode = async (code: string) => {
    setIsFetching(true);
    const result: ServerValidationResult = await fetch(`${url}${code}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.statusText)
        }
        return res.json();
      })
      .catch((err) => {
        setIsFetching(false);
        console.error("Failed to fetch quiz code", err);
      });

    if (result) {
      setIsFetching(false);
    }
    
    return result;
  };

  return { isFetching, validateCode };
};

export default useQuizCodeServerValidation;
